// extracted by mini-css-extract-plugin
export default {"hero":"herosection_hero__TW+i6","logo":"herosection_logo__inSUF","arrow":"herosection_arrow__mdsXD","bounce":"herosection_bounce__z3WOJ"};